var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`bg-primary SisrAccess row container-layout h-100 ${
    _vm.darkMode ? 'DARK_MODE' : ''
  }`},[_c('router-view',{attrs:{"darkMode":_vm.darkMode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }